// src/pages/Godown/ViewGodown.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import godownService from '../../services/godown.service';
import Toast from '../../components/Toast/Toast';
import '../../styles/AddPages.css';

const ViewGodown = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [godown, setGodown]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast]     = useState(null);

  useEffect(() => {
   const fetchGodown = async () => {
  try {
    const res = await godownService.getGodownById(id);
    if (res.success) setGodown(res.data);
  } catch (err) {
    const status = err.response?.status;
    if (status === 404) {
      setToast({ message: 'Godown not found', type: 'error' });
    } else if (status === 403) {
      setToast({ message: 'You do not have access to this godown', type: 'error' });
    } else {
      setToast({ message: 'Failed to fetch godown details', type: 'error' });
    }
  } finally {
    setLoading(false);
  }
};
    fetchGodown();
  }, [id]);

  if (loading)  return <div className="add-godown-page"><p style={{ padding: 40 }}>Loading...</p></div>;
  if (!godown)  return <div className="add-godown-page"><p style={{ padding: 40 }}>Godown not found.</p></div>;

  const Field = ({ label, value }) => (
    <div className="form-group">
      <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>{label}</label>
      <div className="form-input" style={{
        background: '#f8f9fa', cursor: 'default',
        minHeight: 42, display: 'flex', alignItems: 'center',
      }}>
        {value || <span style={{ color: '#aaa' }}>—</span>}
      </div>
    </div>
  );

  // Region chips — gracefully degrades if the array is empty
  const RegionChips = ({ regions }) => {
  if (!regions || regions.length === 0) return <span style={{ color: '#aaa' }}>—</span>;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {regions.map(r => (
        <span key={r.id} style={{
          background: '#e8f5e9', color: '#2e7d32',
          padding: '4px 10px', borderRadius: 12,
          fontSize: 13, fontWeight: 500, border: '1px solid #c8e6c9',
        }}>
          {r.name}{r.company?.name ? ` (${r.company.name})` : ''}
        </span>
      ))}
    </div>
  );
};

  return (
    <div className="add-godown-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/godown/view">Godowns</a></li>
          <li className="breadcrumb-item active">View Godown</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Godown Details</h4>
        <button className="btn btn-primary" onClick={() => navigate(`/godown/edit/${id}`)}>
          ✏️ Edit Godown
        </button>
      </div>

      <div className="form-card">
        <div className="form-section">
          <div className="form-row">
            <Field label="Godown Name" value={godown.name} />
            <Field label="Location"    value={godown.location} />
            <Field label="Manager"     value={godown.manager} />
          </div>

          <div className="form-row">
  <Field label="Status" value={godown.isActive ? '✅ Active' : '❌ Inactive'} />
 
          {/* Regions section — full width, chip layout */}
          {godown.regions?.length > 0 && (
              <div className="form-group" style={{ flex: '1 1 100%' }}>
                <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>
                  Assigned Regions
                </label>
                <div
                  className="form-input"
                  style={{
                    background:   '#f8f9fa',
                    cursor:       'default',
                    minHeight:    42,
                    padding:      '8px 12px',
                    display:      'flex',
                    alignItems:   'center',
                  }}
                >
                  <RegionChips regions={godown.regions} />
                  </div>
                </div>
          )}
          </div>
        </div>

        <div className="form-actions">
          <button className="btn btn-secondary" onClick={() => navigate('/godown/view')}>← Back</button>
          <button className="btn btn-primary"   onClick={() => navigate(`/godown/edit/${id}`)}>✏️ Edit</button>
        </div>
      </div>
    </div>
  );
};

export default ViewGodown;